import CONFIG from '../../js/config';
import { RootStore } from '../../js/stores/root.store';

export function openOptOut(options: FormatOptions) {
  let consentUrl = options.context.optoutUrl;
  if (consentUrl === undefined || consentUrl === null)
    consentUrl = CONFIG.OPT_OUT_SITE_URL;

  RootStore.getInstance().adContainerStore.openAd(consentUrl, true);
}
